import { useGetAllTabsDashboardData } from "@features/ax/dashboard/hooks";
import { assetOverviewData } from "../../../utils";
import { HealthConditionSection } from "./healthAndCondition";
import { PerformanceReliabilitySection } from "./performanceReliability";
import { RiskStrategicSection } from "./riskAndStrategic";
import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";

const Overview = () => {
  const { data: OverviewData } = useGetAllTabsDashboardData("overview");
  useEffect(() => {
    logEvent("Overview Dashboard Viewed", {});
  }, []);
  return (
    <div className="space-y-8">
      <HealthConditionSection data={OverviewData} />
      <PerformanceReliabilitySection data={OverviewData} />
      <RiskStrategicSection data={OverviewData} />
    </div>
  );
};

export default Overview;
